import { isFileTooLarge } from '@utils/file-size';

import { isRealFile } from './utils';

import { FormValidatorFn } from '../types';
import { submitOnlyValidator } from '../validate-form-value';

const validatorCache = new Map<number, FormValidatorFn>();

export const createFileSizeValidator = (maxFileSizeMb: number): FormValidatorFn => {
  const cached = validatorCache.get(maxFileSizeMb);
  if (cached) return cached;

  const validator = submitOnlyValidator((value) => {
    const entries = Array.isArray(value) ? value : [value];
    const hasOversizedFile = entries
      .filter(isRealFile)
      .some((file) => isFileTooLarge(file, maxFileSizeMb));
    return hasOversizedFile ? 'file-size' : true;
  });

  validatorCache.set(maxFileSizeMb, validator);
  return validator;
};
